module.exports = __webpack_public_path__ + "img/pricing-shape-1.f5965b6d.png";